module.exports = __webpack_public_path__ + "00_hair.16609dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/00_hair.png
// module id = Gdhk
// module chunks = 0